import { render, staticRenderFns } from "./DropFileContenidoAcademia.vue?vue&type=template&id=3afebc31&scoped=true"
import script from "./DropFileContenidoAcademia.vue?vue&type=script&lang=js"
export * from "./DropFileContenidoAcademia.vue?vue&type=script&lang=js"
import style0 from "./DropFileContenidoAcademia.vue?vue&type=style&index=0&id=3afebc31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afebc31",
  null
  
)

export default component.exports